module.exports = __webpack_public_path__ + "static/img/20011 (6).3b2cf13.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (6).webp
// module id = z6+w
// module chunks = 14